
import React, { useEffect, useState } from 'react';
// import './App.css';
import { DialogTitle, Paper } from '@mui/material';
import 'react-resizable/css/styles.css';
import Chart from '../charts/chart';
import { useLocation } from 'react-router-dom';

function Preview2() {

    const [viewType, setViewType] = useState('');
    const [widgetData, setWidgetData] = useState<any>('');
    const [print, setPrint] = useState(false);
    const [printObj, setPrintObj] = useState({ print: false, viewType: 'Pie Chart' });

    const location = useLocation();

    function handleAfterPrint(data: any) {
        setPrint(data);
        let obj = { print: data, viewType: printObj.viewType };
        setPrintObj(obj);
        console.log(data);
    }

    // useEffect(() => {
    //     const params = new URLSearchParams(location.search);
    //     const viewTypeParam = params.get('viewType');
    //     const widgetDataParam = params.get('widgetData');

    //     if (viewTypeParam) {
    //         setViewType(viewTypeParam);
    //     }

    //     if (widgetDataParam) {
    //         setWidgetData(JSON.parse(widgetDataParam));
    //     }
    // }, [location]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const viewTypeParam = params.get('viewType');
        const pageKey = params.get('page');  // Get the sessionStorage key from URL (e.g., 'previewData')

        if (viewTypeParam) {
            setViewType(viewTypeParam);
        }

        if (pageKey) {
            const storedWidgetData = sessionStorage.getItem(pageKey);  // Retrieve the widget data from sessionStorage
            if (storedWidgetData) {
                setWidgetData(JSON.parse(storedWidgetData));
            } else {
                console.error('No widget data found in sessionStorage');
            }
        }
    }, [location]);

    return (
        <div>
            <DialogTitle>{"Widget Preview"}</DialogTitle>
            <div>
                <Paper style={{ width: 700, height: 270, margin: 3 }} elevation={3}>
                    {/* <Header data={props.name} /> */}
                    <Chart
                        viewType={viewType}
                        widgetData={widgetData}
                        timeOut={1000}
                        print={printObj}
                        parentCallbackPrint={handleAfterPrint}
                    />
                </Paper>
            </div>
        </div>
    );
}

export default Preview2;
